import { handleToken, STORAGE } from "src/auth/mutations";
import { create } from "zustand";

interface TokenState {
  token: string | null;
  setToken: (t: string | null) => void;
}

function getInitialToken() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("token");
  if (urlToken) {
    return urlToken;
  }
  return STORAGE.getToken() || null;
}

// Set bearer token + localStorage before any component renders
let initialToken: string | null = getInitialToken();
if (initialToken) {
  try {
    handleToken(initialToken);
  } catch {
    STORAGE.clearToken();
    initialToken = null;
  }
}

export const useTokenStore = create<TokenState>()((set) => ({
  token: initialToken,
  setToken: (t) => set({ token: t }),
}));
